

import { useState } from "react";
import '../pages/SettingPageuser.css'
import './EditModalDam.css'
import { useGlobalContext } from "./Context";
import { useDispatch, useSelector } from "react-redux";
import {  toast } from "react-toastify";

import { useNavigate, useParams } from "react-router-dom";
import { loginSuccessSensor } from "../redux/slices/singleSensorSlice";
import { loginSuccessAllSens } from "../redux/slices/allSensorSlice";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';

import apiService from "../api/ApiService";
import { useEffect } from "react";
import { loginSuccessC } from "../redux/slices/singleCattleSlice";
import { useForm } from "react-hook-form";
import { isEqual } from "./EditModalDam";
import { Close, Report, Warning } from "@mui/icons-material";


const ChangeStatus=({tit,idd})=>{
    const [valid,setValid]=useState(false)
    const [AllStatus,setAllStatus]=useState([])
    const mainProp={cattleStatusId:idd}
    const {openModallTime,closeModallTime,isModalTimeOpen}=useGlobalContext();
    const {id}=useParams()
    const dispatch=useDispatch();
    const {watch,
        register,
        handleSubmit,
        formState: { errors }
      } = useForm({defaultValues:mainProp});
    const getStatus=async()=>{
                const res=await apiService.getStatusList()
                const filtered=res.data.filter(item=>{
                    return item?.id!=idd
                })
                setAllStatus(filtered)
        }
useEffect(()=>{
    getStatus()
},[])
const allData=watch()
useEffect(()=>{setValid(isEqual(mainProp,allData))},[allData])

    const updateStatus=async(data)=>{           
                        const res=await apiService.changeCattleStatus(id,data)
                        dispatch(loginSuccessC(res.data))
                        openModallTime()
    }
    

    return <div onClick={closeModallTime} className={`modal-overlay ${isModalTimeOpen&&'show-modal'} `}>
        <form onSubmit={handleSubmit(updateStatus)} className="editModalDamCon Ani AllFFFF" >
        <div className="closee"><Close className='closee'/></div>
            <div className="editModalDamConHead">
            <DriveFileRenameOutlineIcon fontSize="large"/>

            <h4 > تغییر وضعیت دام</h4>
            </div>
       
            <div className="SelConn">
        <label for='sele' ><Report fontSize="small"/> وضعیت:</label>
        <select  id='sele'  name='sele' className="selectInp"  {...register("cattleStatusId",{required:'این مقدار ضروری است'})} >
        <option value={idd}>{tit}</option>

            {AllStatus?.map((item,index)=>{

                return <option key={index} value={item.id}>{item.title}</option>
            })}
        </select>
        </div>
        
        <button disabled={valid} className="EditMOdalBtnForm">
            تایید
        </button>
        
        </form>
        <div style={{marginTop:'220px'}}> 
        
        </div>
        
    </div>
}
export default ChangeStatus